import { render, staticRenderFns } from "./CourtOutcome.vue?vue&type=template&id=f28d02d2&scoped=true&"
import script from "./CourtOutcome.vue?vue&type=script&lang=js&"
export * from "./CourtOutcome.vue?vue&type=script&lang=js&"
import style0 from "./CourtOutcome.vue?vue&type=style&index=0&id=f28d02d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28d02d2",
  null
  
)

export default component.exports